import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LogementItems } from "@/components/LogementItems";
import { api, errMsg } from "@/lib/api";

export const COMMUN = "__commun__";
const PARTAGE = "__partage__";

export const TxLogementSelect = ({ tx, logements, onChanged }) => {
  const partage = Array.isArray(tx.logement);
  const change = async (v) => {
    if (v === PARTAGE) return;
    const logement = v === "none" ? "" : v;
    try {
      const { data } = await api.put(`/transactions/${tx.id}/logement`, { logement });
      onChanged();
      if (data.similaires > 0) {
        toast.success("Charge affectée", {
          description: `${data.similaires} autre(s) opération(s) « ${tx.description} » non affectée(s).`,
          action: {
            label: "Appliquer aussi",
            onClick: () => api.post(`/transactions/${tx.id}/similaires`).then((r) => { toast.success(`${r.data.modifiees} opération(s) affectée(s)`); onChanged(); }).catch((e) => toast.error(errMsg(e))),
          },
        });
      } else toast.success(logement ? "Charge affectée" : "Affectation retirée");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex items-center gap-1.5">
      <Select value={partage ? PARTAGE : tx.logement || "none"} onValueChange={change}>
        <SelectTrigger className="h-8 w-44 text-xs" data-testid={`tx-logement-${tx.id}`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none" data-testid="tx-logement-option-none">Non affectée (perso)</SelectItem>
          <LogementItems logements={logements} testPrefix="tx-logement-option" />
          <SelectItem value={COMMUN} data-testid="tx-logement-option-commun">Commun (réparti)</SelectItem>
          {partage && <SelectItem value={PARTAGE} data-testid="tx-logement-option-partage">{tx.logement.join(" + ")}</SelectItem>}
        </SelectContent>
      </Select>
      {tx.logement_source === "regle" && <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] font-mono uppercase text-emerald-700" title="Affectée par une règle" data-testid={`tx-regle-badge-${tx.id}`}>auto</span>}
    </div>
  );
};
